import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = String(FIREBASE_CONFIG?.projectId || '').trim();

export async function enrollClientMfa(clientId, pinHashValue) {
  const ref = doc(db, 'artifacts', appId, 'public', 'data', 'clients', clientId);
  await updateDoc(ref, {
    'security.pinHash': pinHashValue,
    'security.mfaEnabled': true,
    'security.mfaEnrolledAt': serverTimestamp(),
  });
}
